import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CommitteeMembersComponent } from './committee-members/committee-members.component';
import { MainMemberListComponent } from './main-member-list/main-member-list.component';
import { MemberDetailsComponent } from './member-details/member-details.component';
import { MemberDeleteComponent } from './member-delete/member-delete.component';
import { ActivememberComponent } from './activemember/activemember.component';
import { VillageListComponent } from './village-list/village-list.component';
import { VillageMemberListComponent } from './village-member-list/village-member-list.component';
import { ActivistComponent } from './activist/activist.component';
import { ActivistMemberListComponent } from './activist-member-list/activist-member-list.component';
import { AllmemberlistComponent } from './allmemberlist/allmemberlist.component';

const routes: Routes = [
  { path: '', component: CommitteeMembersComponent },
  { path: 'committee-members', component: CommitteeMembersComponent },
  { path: 'main-member-list', component: MainMemberListComponent },
  { path: 'member-details/:id', component: MemberDetailsComponent },
  { path: 'member-delete', component: MemberDeleteComponent },
  { path: 'village-list', component: VillageListComponent },
  { path: 'village-member-list/:villageId', component: VillageMemberListComponent },
  { path: 'isactive', component: ActivememberComponent },
  { path: 'activist-member', component: ActivistComponent },
  { path: 'activist-member-list/:id', component: ActivistMemberListComponent },
  { path: 'all-member-list', component: AllmemberlistComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CommitteeRoutingModule { }
